/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseCampaignDto } from '../../models/recourse-campaign-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAllRecourseCampaigns$Params {}

export function getAllRecourseCampaigns(
  http: HttpClient,
  rootUrl: string,
  params?: GetAllRecourseCampaigns$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecourseCampaignDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllRecourseCampaigns.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecourseCampaignDto>>;
    }),
  );
}

getAllRecourseCampaigns.PATH = '/service/v1/recourseCampaign';
